module.exports = __webpack_public_path__ + "img/dark-theme.9da7aab6.jpg";